import { actions } from './actions'

const initialState = {
  mailTemplate: {
    data: null,
    loading: false,
    error: '',
  },
  mailTemplateList: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function mailTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case actions.MAIL_TEMPLATE_LIST_LOAD_REQUESTED:
      return { ...state, mailTemplateList: { ...state.mailTemplateList, loading: true } }
    case actions.MAIL_TEMPLATE_LIST_LOAD_SUCCEEDED:
      return {
        ...state,
        mailTemplateList: { ...state.mailTemplateList, data: action.payload, loading: false },
      }
    case actions.MAIL_TEMPLATE_LIST_LOAD_FAILED:
      return {
        ...state,
        mailTemplateList: { ...state.mailTemplateList, loading: false, error: action.error },
      }
    case actions.MAIL_TEMPLATE_BY_ID_LOAD_REQUESTED:
      return { ...state, mailTemplate: { ...state.mailTemplate, loading: true } }
    case actions.MAIL_TEMPLATE_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        mailTemplate: { ...state.mailTemplate, data: action.payload, loading: false },
      }
    case actions.MAIL_TEMPLATE_BY_ID_LOAD_FILED:
      return {
        ...state,
        mailTemplate: { ...state.mailTemplate, loading: false, error: action.error },
      }
    case actions.MAIL_TEMPLATE_UPDATE_REQUESTED:
      return {
        ...state,
        mailTemplate: { ...state.mailTemplate, loading: true, error: '' },
      }
    case actions.MAIL_TEMPLATE_UPDATE_SUCCEEDED:
      return {
        ...state,
        mailTemplate: {
          ...state.mailTemplate,
          data: action.payload,
          loading: false,
          error: '',
        },
        mailTemplateList: {
          ...state.mailTemplateList,
          data: state.mailTemplateList.data.map(template =>
            template.id === action.payload.id ? action.payload : template,
          ),
          loading: false,
        },
      }
    case actions.MAIL_TEMPLATE_UPDATE_FILED:
      return {
        ...state,
        mailTemplate: { ...state.mailTemplate, loading: false, error: action.error },
      }
    case actions.MAIL_TEMPLATE_INSERT_SUCCEEDED:
      return {
        ...state,
        mailTemplate: {
          ...state.mailTemplate,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    default:
      return state
  }
}
